export const SELECTOR_DROPDOWN_WIDTH = 150; // TODO: should push backend to return standardized ISO format

export const VINTED_LOCALE_TO_ISO_MAP = {
  'en-dev': 'en',
  en: 'en',
  'cz-fr': 'cs',
  cz: 'cs',
  'fi-fr': 'fi-FI',
  'nl-fr': 'nl',
  'en-fr': 'en',
  'en-uk-fr': 'en-GB',
  'en-us-fr': 'en-US',
  'es-us-fr': 'es-US',
  fr: 'fr',
  'de-fr': 'de',
  'da-fr': 'da-DK',
  'it-fr': 'it',
  'lt-fr': 'lt',
  pl: 'pl',
  'pl-fr': 'pl',
  'pt-fr': 'pt',
  'es-fr': 'es',
  'sk-fr': 'sk',
  'hu-fr': 'hu',
  'sv-fr': 'sv',
  'ro-fr': 'ro',
  'en-ca-fr': 'en-CA',
  'fr-ca-fr': 'fr-CA',
  keys: 'en'
};